"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormItemInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormItemTemplate_1 = require("../FormItemTemplate");
const formik_1 = require("formik");
const FormItemInput = ({ onChange, onKeyDown, onBlur, type = "text", ...props }) => {
    const { readonly, required, value } = props;
    const [fieldsProps, _, helpers] = (0, formik_1.useField)(props.name);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(FormItemTemplate_1.FormItemTemplate, { ...props, renderEdit: (0, jsx_runtime_1.jsx)("input", { ...fieldsProps, value: value, onKeyDown: onKeyDown, type: type, onChange: onChange, className: "form-control", disabled: readonly, required: required }) }) }));
};
exports.FormItemInput = FormItemInput;
